import * as React from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';


interface IProps {
  content: any;
  onChange?: any;
  id: string;
}
interface IState { }

class DABHtmlEditor extends React.Component<IProps, IState>  {
  constructor(props: any) {
    super(props);
  }

  render() {
    return (
		<CKEditor
			key={this.props.id}
			editor={ClassicEditor}
			onReady={editor => { }}
			data={this.props.content}
			onChange={(event, editor)=>this.props.onChange(editor)}
			config={{
				toolbar: ['bold', '|', 'italic', '|', 'bulletedList', '|', 'numberedList', '|', 'blockQuote', 'increaseIntent'],
				removePlugins: ['scayt', 'about', 'specialchar', 'elementspath', 'resize'],
				placeholder: "type your description here...",
				fontFamily: ['sans-serif']
			}}
			onError={(error, { willEditorRestart }) => {}}
      />)
  }
}

export default DABHtmlEditor;
